export class KVG1N6Annotation {
  damageCategory: 'Structural' | 'Coating' | 'Outfitting' | ''
  section: string
  component: string
  damageType: string
  localizedScattered: 'Local' | 'Scattered' | ''
  insulationSection: string
  severity: string
  locationTransverse: string
  locationLongitudinal: string
  locationVertical: string
  width: string
  height: string

  constructor() {
    this.damageCategory = ''
    this.section = ''
    this.component = ''
    this.damageType = ''
    this.localizedScattered = ''
    this.insulationSection = ''
    this.severity = 'N/V'
    this.locationTransverse = ''
    this.locationLongitudinal = ''
    this.locationVertical = ''
    this.width = ''
    this.height = ''
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  static fromJSON(json: any): KVG1N6Annotation {
    const annotation = new KVG1N6Annotation()
    if (json.damageCategory !== undefined)
      annotation.damageCategory = json.damageCategory
    if (json.section !== undefined) annotation.section = json.section
    if (json.component !== undefined) annotation.component = json.component
    if (json.damageType !== undefined) annotation.damageType = json.damageType
    if (json.localizedScattered !== undefined)
      annotation.localizedScattered = json.localizedScattered
    if (json.insulationSection !== undefined)
      annotation.insulationSection = json.insulationSection
    if (json.severity !== undefined) annotation.severity = json.severity
    if (json.locationTransverse !== undefined)
      annotation.locationTransverse = json.locationTransverse
    if (json.locationLongitudinal !== undefined)
      annotation.locationLongitudinal = json.locationLongitudinal
    if (json.locationVertical !== undefined)
      annotation.locationVertical = json.locationVertical
    if (json.width !== undefined) annotation.width = json.width
    if (json.height !== undefined) annotation.height = json.height

    return annotation
  }

  static toJSON(annotation: KVG1N6Annotation): any {
    return {
      damageCategory: annotation.damageCategory,
      section: annotation.section,
      component: annotation.component,
      damageType: annotation.damageType,
      localizedScattered: annotation.localizedScattered,
      insulationSection: annotation.insulationSection,
      severity: annotation.severity,
      locationTransverse: annotation.locationTransverse,
      locationLongitudinal: annotation.locationLongitudinal,
      locationVertical: annotation.locationVertical,
      width: annotation.width,
      height: annotation.height,
    }
  }
}
